import colors from '../../style/css/shared/colors.json';

const brightColors = ['color-warmup-corn', 'color-coldplay-khaki'];

export const defaultChartColors = Object.keys(colors)
    .reverse()
    .filter(key => !brightColors.includes(key))
    .map(key => colors[key]);

export const getFromDefaultColors = (entry, index) => defaultChartColors[index];

export const getColor = colorKey => colors[colorKey];
